import { render, staticRenderFns } from "./BelowCompany.vue?vue&type=template&id=2c0d10e5&scoped=true&"
import script from "./BelowCompany.vue?vue&type=script&lang=js&"
export * from "./BelowCompany.vue?vue&type=script&lang=js&"
import style0 from "./BelowCompany.vue?vue&type=style&index=0&id=2c0d10e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0d10e5",
  null
  
)

export default component.exports